<template>
<v-card v-if="monthlySales">
    <v-card-title class="subtitle-1">
        <v-icon color="indigo lighten-1" class="mr-3">mdi-chart-line</v-icon>월별매출통계
    </v-card-title>
    <v-card-text>
        <v-responsive width="100%" height="196">
            <v-chart :options="monthlySalesOption" />
        </v-responsive>
    </v-card-text>
</v-card>
</template>

<script>
import api from "@/api";

import ECharts from 'vue-echarts';
export default {
    components: {
        'v-chart': ECharts,
    },
    data(){
        return {
            filter: {
                startDate: (new Date().addYear(-1)).toDate().substr(0, 7),
                endDate: Date.now().toDate().substr(0, 7)
            },

            monthlySales: null
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search();
        },
        async search(){
            try{
                var { monthlySales } = await api.console.statistics.getMonthlySales({
                    params: this.filter
                });

                this.monthlySales = monthlySales;
            }
            catch(error){
                console.error(error);
            }
        }
    },
    computed: {
        monthlySalesOption(){
            var xAxisData = [];
            for(var date = new Date(this.filter.startDate); date <= new Date(this.filter.endDate); date.addMonth(1)){
                xAxisData.push(date.getTime().toDate().substr(0, 7));
            }
            return {
                color: this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? "dark" : "light"].primary,
                grid: {
                    width: "100%",
                    left: "0%",
                    top: '5%',
                    bottom: '0%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    data: xAxisData
                },
                yAxis: {
                    type: 'value',
                },
                tooltip: {
                    trigger: 'axis',
                },
                series: [{
                    data: this.monthlySales.map((statistic) => statistic.totalPrice),
                    type: 'line',
                    areaStyle: {}
                }]
            };
        },
    }
}
</script>
